import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { isEmpty } from 'validate.js';

import Input from 'dpl/common/design_system/Input';
import FancyDropdown, {
  FancyDropdownMenu,
  FancyDropdownMenuItem
} from 'dpl/components/FancyDropdown';

import { LocationResultsResultGoogleItem } from '../components/LocationResultsList';

export default function LocationAutocomplete({
  onSelect,
  onResultsChange,
  query,
  googlePlacesResults,
  inputProps,
  menuPosition,
  menuClassName,
  menuCloseTimeout
}) {
  const [isOpen, setIsOpen] = useState(false);

  function handleInputFocus() {
    setIsOpen(true);
    inputProps.onFocus?.();
  }

  function handleInputBlur() {
    setTimeout(() => {
      setIsOpen(false);
      inputProps.onBlur?.();
    }, menuCloseTimeout);
  }

  useEffect(() => {
    onResultsChange?.(googlePlacesResults);
  }, [googlePlacesResults]);

  return (
    <div className="LocationAutocomplete">
      <FancyDropdown
        onChange={setIsOpen}
        isOpen={isOpen}
        menuPosition={menuPosition}
      >
        <Input
          {...inputProps}
          type="text"
          autoComplete="off"
          value={query}
          onBlur={handleInputBlur}
          onFocus={handleInputFocus}
        />
        {!isEmpty(googlePlacesResults) && (
          <div role="presentation" onMouseDown={e => e.preventDefault()}>
            <FancyDropdownMenu
              className={classnames(
                'bg-white overflow-scroll no-scrollbars overflow-x-hidden',
                menuClassName
              )}
            >
              {googlePlacesResults.map(place => (
                <FancyDropdownMenuItem key={place.name} itemKey={place.name}>
                  <LocationResultsResultGoogleItem
                    place={place}
                    onClick={onSelect}
                  />
                </FancyDropdownMenuItem>
              ))}
            </FancyDropdownMenu>
          </div>
        )}
      </FancyDropdown>
    </div>
  );
}

LocationAutocomplete.propTypes = {
  menuClassName: PropTypes.string,
  menuPosition: PropTypes.oneOf(['left', 'right', 'static']),
  menuCloseTimeout: PropTypes.number,
  onSelect: PropTypes.func.isRequired,
  query: PropTypes.string.isRequired,
  googlePlacesResults: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      getCoordinates: PropTypes.func.isRequired
    })
  ).isRequired,
  inputProps: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func
  }).isRequired,
  onResultsChange: PropTypes.func
};

LocationAutocomplete.defaultProps = {
  menuClassName: null,
  menuPosition: 'left',
  menuCloseTimeout: 0,
  onResultsChange: null
};
